<div class="mobile-brand-bar">
  <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="24px"
    url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
  <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="24px"
    url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
  <div class="cta-wrapper">
    {{ctaText}}
  </div>
</div>

<app-split-page-wrapper>
  <div left>
    <div class="brand-element">
      <div class="logo-wrapper">
        <div class="logo-ball"></div>
        <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="34px"
          url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
        <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="34px"
          url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
      </div>
      <div class="cta-wrapper">
        {{ctaText}}
      </div>
    </div>
  </div>
  <div right>
    <div class="auth-form-wrapper">
      <h2>Reset Password</h2>
      <ng-container *ngIf="!resetSuccessful; else successTemplate">
        <app-password-strength-input id="newPassword" placeholder="new password" mb="14px" [(ngModel)]="password"
          isFluid="true" autocomplete="new-password" (focusEvent)="resetError()"></app-password-strength-input>
        <app-password-strength-input id="confirmPassword" placeholder="confirm password" mb="24px" [(ngModel)]="confirmPassword"
          isFluid="true" autocomplete="new-password" (focusEvent)="resetError()"></app-password-strength-input>

        <app-alert-message *ngIf="errorMessage" type="error" mb="24px">{{errorMessage}}</app-alert-message>

        <app-primary-btn (click)="resetPassword()" mb="24px" [disabled]="isSubmitting" gradient="true">
          <span *ngIf="!isSubmitting">Reset Password</span>
          <app-spinner variant="btn-spinner" *ngIf="isSubmitting" size="20px"></app-spinner>
        </app-primary-btn>
        <div class="auth-link-wrap">
          <a class="link" [routerLink]="['/login']">Back to Login</a>
        </div>
      </ng-container>
      <ng-template #successTemplate>
        <app-alert-message type="success" mb="24px">✅ Your password was reset. Redirecting to login in {{countdown}}
          seconds…</app-alert-message>
        <app-primary-btn (click)="loginNow()" mb="24px" gradient="true">Login Now</app-primary-btn>
      </ng-template>
    </div>
  </div>
</app-split-page-wrapper>